import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Contractul lui GET /api/v2/settings/drawer (v4/api, App\Settings\Drawer\SettingsDrawer).
 *
 * Tot ce vine de aici e DEJA filtrat pe drepturi, pe server - ca la
 * `InventoreeSettings::shell()`. Interfata deseneaza ce a primit si nu intreaba
 * nimic despre roluri: o poarta desenata in browser nu e o poarta.
 */

/** Capul sertarului: chipul, numele, departamentul, si contul de sub ele. */
export interface DrawerAccount {
  name: string
  department: string
  /** Adresa chipului pe serverul de descarcari; sirul gol = nu se deseneaza. */
  avatar: string
  /** Adresa ecranului "My Account", sau `null` cand omul n-are dreptul. */
  myAccount: string | null
}

/** Un modul al firmei care isi arata setarile ("Modules Settings"). */
export interface DrawerModule {
  slug: string
  name: string
}

/** Un drum scurt din grupul "In General" (seiful si rapoartele). */
export interface DrawerShortcut {
  id: string
  label: string
  icon: string
  url: string
  hint: string
  /** Culoarea NUMELUI, cand randul o cere (seiful e rosu); sirul gol = culoarea listei. */
  color: string
}

/** O zona de setari, cu primul ei ecran vizibil. */
export interface DrawerZone {
  key: string
  label: string
  url: string
  hint: string
}

export interface SettingsDrawerData {
  account: DrawerAccount
  modules: DrawerModule[]
  general: DrawerShortcut[]
  zones: DrawerZone[]
  changeProposals: boolean
}

export function settingsDrawerQuery() {
  return queryOptions({
    queryKey: ['settings-drawer'],
    queryFn: () => apiGet<SettingsDrawerData>('/settings/drawer'),
    staleTime: 5 * 60 * 1000,
  })
}
